import * as React from 'react';
import { ArrowForward, InfoDetails } from '../../../../Icons';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../../../theme';
const Options = ({ product, onRulesOpen }) => {
    var _a, _b;
    const { t } = useTranslation('ServiceAggregation');
    const theme = useTheme('CheckoutAdditionalService').EveryPortLounge;
    if (!product.notes.length && !((_a = product.terms[0]) === null || _a === void 0 ? void 0 : _a.url)) {
        return null;
    }
    return (React.createElement("div", { onClick: onRulesOpen, className: theme.notice },
        React.createElement("div", { className: theme.notice__icon }, InfoDetails),
        React.createElement("div", { className: theme.notice__notes }, !product.notes.length && ((_b = product.terms[0]) === null || _b === void 0 ? void 0 : _b.url)
            ? t('Read the rules of service')
            : product.notes.slice(0, 3).map((note, key) => React.createElement("span", { key: key },
                note,
                ". "))),
        React.createElement("div", { className: theme.notice__link },
            t('All conditions'),
            " ",
            ArrowForward)));
};
export default Options;
